import { IOption } from "Dashboard/domain/IOption";
import { forwardRef, useEffect, useState } from "react";
import Select from "react-select";
import { resourceTypeDictionary } from "utils/translationDictionary";
import { resourcesServices } from "../services/resource.service";

const TypeSelect = forwardRef<any, any>((props, ref) => {
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState<IOption[]>([]);
  const [value, setValue] = useState<IOption | undefined>(undefined);

  useEffect(() => {
    async function getData() {
      const types = await resourcesServices.getResourcesTypes();
      const op = types.map((type) => {
        return {
          label: resourceTypeDictionary[type.name],
          value: type.typeId,
        };
      });
      setOptions(op);
      setIsLoading(false);
    }

    try {
      getData();
    } catch (err) {
      console.log(err);
    }
  }, []);

  const handleChange = (newValue: any, actionMeta: any) => {
    setValue(newValue);
    props.onChange(newValue ? newValue.value : null);
  };

  return (
    <Select
      isClearable
      styles={props.customStyles}
      ref={ref}
      options={options}
      value={value}
      onChange={handleChange}
      placeholder={""}
      loadingMessage={() => "Učitavanje..."}
      noOptionsMessage={() => "Ne postoji"}
      isLoading={isLoading}
      {...{ error: props.error }}
    />
  );
});

export default TypeSelect;
